import { svg } from "lit";
const icon = svg `<path d="M11.25 19.5V7.37303L5.55382 13.0692L4.5 12L12 4.5L19.5 12L18.4461 13.0692L12.75 7.37303V19.5H11.25Z" fill="currentColor"/>`;
export default icon;
